var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1651.693,
    height: 1651.694,
    viewBox: "0 0 1651.693 1651.694",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.024,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ff5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0014ff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_44",
    "data-name": "Union 44",
    d: "M61.438,501.061A210.071,210.071,0,0,1,0,352.209V210.323C.159,94.212,94.16.132,210.139,0h531.25A209.552,209.552,0,0,1,886.658,58.5,209.548,209.548,0,0,1,1031.925,0h531.346c115.943.184,209.888,94.248,210.044,210.323V352.209a209.868,209.868,0,0,1-210.144,210.323H1031.925A209.629,209.629,0,0,1,886.659,504.39a209.633,209.633,0,0,1-145.27,58.142H209.707A209.6,209.6,0,0,1,61.438,501.061ZM961.973,210.323V352.209a71.1,71.1,0,0,0,69.952,70.413h531.346a70.425,70.425,0,0,0,70.048-70.413V210.323a69.552,69.552,0,0,0-70.048-69.449H1031.925A70.232,70.232,0,0,0,961.973,210.323Zm-821.877,0V352.209a71.1,71.1,0,0,0,70.048,70.413H741.389a70.472,70.472,0,0,0,70.048-70.413V210.323a69.6,69.6,0,0,0-70.048-69.449H210.143A70.228,70.228,0,0,0,140.1,210.323Z",
    transform: "translate(0 1253.923) rotate(-45)",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavIcon);
export default __webpack_public_path__ + "static/media/Fav_icon.02671fa457ba4ad483b569f36822318d.svg";
export { ForwardRef as ReactComponent };